module.exports = __webpack_public_path__ + "assets/img/bc5ac3089234188684975da70973e67f.png";